import Router from 'vue-router';

//加载组件function
const importPage = (viewUrl) => {
    // return require(`@/views/${viewUrl}`)
    // 按需加载路由
    return () => import(`@/views/${viewUrl}`);
};

// Vue.use(Router)

let routers = [
    {
        path: '/index',
        redirect: '/index',
        name: 'home',
        title: '统计报表',
        iconCls: 'iconfont icondanweiguanli',
        hideArrow: true, //是否隐藏菜单右侧箭头
        // 父路由组件内必须包含 <router-tab>
        component: importPage('home'),

        // 子路由里配置需要通过页签打开的页面路由
        children: [
            {
                path: '/index',
                component: importPage('chartPage/chartPage'),
                name: 'chartPage',
                title: '统计报表',
                meta: {
                    title: '统计报表', // 页签标题
                    icon: 'icon-user', // 页签图标，可选
                    tips: '', // 页签提示，可选，如未设置则跟title一致
                    aliveId: 'fullPath' // 路由打开页签规则，可选
                },
                hidden: true //是否隐藏菜单
            }
        ]
    },
    {
        path: '/',
        redirect: '',
        name: 'home',
        title: '业主信息',
        iconCls: 'iconfont iconshebeizhuangtai',
        hideArrow: false, //是否隐藏菜单右侧箭头
        component: importPage('home'),

        // 子路由里配置需要通过页签打开的页面路由
        children: [
            {
                path: '/managementOrganization',
                component: importPage('infoManagement/managementOrganization'),
                name: 'managementOrganization',
                title: '监管机构管理',
                meta: {
                    title: '监管机构管理', // 页签标题
                    icon: 'icon-user', // 页签图标，可选
                    tips: '', // 页签提示，可选，如未设置则跟title一致
                    aliveId: 'fullPath' // 路由打开页签规则，可选
                },
                hidden: false //是否隐藏菜单
            },
            {
                path: '/monitoringOrganization',
                component: importPage('infoManagement/monitoringOrganization'),
                name: 'monitoringOrganization',
                title: '值守机构管理',
                meta: {
                    title: '值守机构管理',
                    icon: 'icon-user',
                    tips: '',
                    aliveId: 'fullPath',
                },
                hidden: false //是否隐藏菜单
            },
            {
                path: '/organationManage',
                component: importPage('infoManagement/organationManage'),
                name: 'organationManage',
                title: '机构管理',
                meta: {
                    title: '机构管理', // 页签标题
                    icon: 'icon-user', // 页签图标，可选
                    tips: '', // 页签提示，可选，如未设置则跟title一致
                    aliveId: 'fullPath' // 路由打开页签规则，可选
                },
                hidden: false //是否隐藏菜单
            },
            {
                path: '/comboManagement',
                component: importPage('infoManagement/comboManagement'),
                name: 'comboManagement',
                title: '套餐管理',
                meta: {
                    title: '套餐管理', // 页签标题
                    icon: 'icon-user', // 页签图标，可选
                    tips: '', // 页签提示，可选，如未设置则跟title一致
                    aliveId: 'fullPath' // 路由打开页签规则，可选
                },
                hidden: false //是否隐藏菜单
            },
            {
                path: '/equipInfo',
                component: importPage('infoManagement/equipInfo'),
                name: 'equipInfo',
                title: '设备信息',
                meta: {
                    title: '设备信息', // 页签标题
                    icon: 'icon-user', // 页签图标，可选
                    tips: '', // 页签提示，可选，如未设置则跟title一致
                    aliveId: 'fullPath' // 路由打开页签规则，可选
                },
                hidden: false //是否隐藏菜单
            },
            {
                path: '/netManageInfo',
                component: importPage('infoManagement/netManage'),
                name: 'netManageInfo',
                title: '网关信息',
                meta: {
                    title: '网关信息', // 页签标题
                    icon: 'icon-user', // 页签图标，可选
                    tips: '', // 页签提示，可选，如未设置则跟title一致
                    aliveId: 'fullPath' // 路由打开页签规则，可选
                },
                hidden: false //是否隐藏菜单
            },
            {
                path: '/buildManage',
                component: importPage('infoManagement/buildManage'),
                name: 'buildManage',
                title: '建筑管理',
                meta: {
                    title: '建筑管理', // 页签标题
                    icon: 'icon-user', // 页签图标，可选
                    tips: '', // 页签提示，可选，如未设置则跟title一致
                    aliveId: 'fullPath' // 路由打开页签规则，可选
                },
                hidden: false //是否隐藏菜单
            }
        ]
    },
    {
        path: '/',
        redirect: '',
        name: 'home',
        title: '报警管理',
        iconCls: 'iconfont iconshebeizhuangtai',
        hideArrow: false, //是否隐藏菜单右侧箭头
        component: importPage('home'),

        // 子路由里配置需要通过页签打开的页面路由
        children: [
            {
                path: '/alarmManage',
                component: importPage('alarmManage/alarmManage'),
                name: 'alarmManage',
                title: '报警管理',
                meta: {
                    title: '报警管理', // 页签标题
                    icon: 'icon-user', // 页签图标，可选
                    tips: '', // 页签提示，可选，如未设置则跟title一致
                    aliveId: 'fullPath' // 路由打开页签规则，可选
                },
                hidden: false //是否隐藏菜单
            },
            {
                path: '/alarmNoticeManage',
                component: importPage('alarmManage/alarmNoticeManage'),
                name: 'alarmNoticeManage',
                title: '报警通知管理',
                meta: {
                    title: '报警通知管理', // 页签标题
                    icon: 'icon-user', // 页签图标，可选
                    tips: '', // 页签提示，可选，如未设置则跟title一致
                    aliveId: 'fullPath' // 路由打开页签规则，可选
                },
                hidden: false //是否隐藏菜单
            },
            {
                path: '/alarmSettingManage',
                component: importPage('alarmManage/alarmSettingManage'),
                name: 'alarmSettingManage',
                title: '报警阈值设置',
                meta: {
                    title: '报警阈值设置', // 页签标题
                    icon: 'icon-user', // 页签图标，可选
                    tips: '', // 页签提示，可选，如未设置则跟title一致
                    aliveId: 'fullPath' // 路由打开页签规则，可选
                },
                hidden: false //是否隐藏菜单
            }
        ]
    },
    {
        path: '/modelManage',
        redirect: '/modelManage',
        name: 'home',
        title: '功能模块管理',
        iconCls: 'iconfont icontongzhigonggao',
        hideArrow: true, //是否隐藏菜单右侧箭头
        component: importPage('home'),

        // 子路由里配置需要通过页签打开的页面路由
        children: [
            {
                path: '/modelManage',
                component: importPage('modelManage/modelManage'),
                name: 'modelManage',
                title: '功能模块管理',
                meta: {
                    title: '功能模块管理', // 页签标题
                    icon: 'icon-user', // 页签图标，可选
                    tips: '', // 页签提示，可选，如未设置则跟title一致
                    aliveId: 'fullPath' // 路由打开页签规则，可选
                },
                hidden: true //是否隐藏菜单
            }
        ]
    },
    {
        path: '/modelManageUser',
        redirect: '/modelManageUser',
        name: 'home',
        title: '业主功能模块管理',
        iconCls: 'iconfont icontongzhigonggao',
        hideArrow: true, //是否隐藏菜单右侧箭头
        component: importPage('home'),

        // 子路由里配置需要通过页签打开的页面路由
        children: [
            {
                path: '/modelManageUser',
                component: importPage('modelManageUser/modelManage'),
                name: 'modelManageUser',
                title: '业主功能模块管理',
                meta: {
                    title: '业主功能模块管理', // 页签标题
                    icon: 'icon-user', // 页签图标，可选
                    tips: '', // 页签提示，可选，如未设置则跟title一致
                    aliveId: 'fullPath' // 路由打开页签规则，可选
                },
                hidden: true //是否隐藏菜单
            }
        ]
    },
    {
        path: '/customManage',
        redirect: '/customManage',
        name: 'home',
        title: '定制管理',
        iconCls: 'iconfont icontongzhigonggao',
        hideArrow: true, //是否隐藏菜单右侧箭头
        component: importPage('home'),

        // 子路由里配置需要通过页签打开的页面路由
        children: [
            {
                path: '/customManage',
                component: importPage('customManage/customManage'),
                name: 'customManage',
                title: '定制管理',
                meta: {
                    title: '定制管理', // 页签标题
                    icon: 'icon-user', // 页签图标，可选
                    tips: '', // 页签提示，可选，如未设置则跟title一致
                    aliveId: 'fullPath' // 路由打开页签规则，可选
                },
                hidden: true //是否隐藏菜单
            }
        ]
    },
    {
        path: '/parseManage',
        redirect: '/parseManage',
        name: 'home',
        title: '解析程序管理',
        iconCls: 'iconfont icontongzhigonggao',
        hideArrow: true, //是否隐藏菜单右侧箭头
        component: importPage('home'),

        // 子路由里配置需要通过页签打开的页面路由
        children: [
            {
                path: '/parseManage',
                component: importPage('parseManage/parseManage'),
                name: 'parseManage',
                title: '解析程序管理',
                meta: {
                    title: '解析程序管理', // 页签标题
                    icon: 'icon-user', // 页签图标，可选
                    tips: '', // 页签提示，可选，如未设置则跟title一致
                    aliveId: 'fullPath' // 路由打开页签规则，可选
                },
                hidden: true //是否隐藏菜单
            }
        ]
    },
    {
        path: '/',
        redirect: '',
        name: 'home',
        title: '设备管理',
        iconCls: 'iconfont iconshebeizhuangtai',
        hideArrow: false, //是否隐藏菜单右侧箭头
        component: importPage('home'),

        // 子路由里配置需要通过页签打开的页面路由
        children: [
            {
                path: '/wisdomScreen',
                component: importPage('equipManage/wisdomScreen'),
                name: 'wisdomScreen',
                title: '智慧屏型号管理',
                meta: {
                    title: '智慧屏型号管理', // 页签标题
                    icon: 'icon-user', // 页签图标，可选
                    tips: '', // 页签提示，可选，如未设置则跟title一致
                    aliveId: 'fullPath' // 路由打开页签规则，可选
                },
                hidden: false //是否隐藏菜单
            },
            {
                path: '/wisdomScreenSoftware',
                component: importPage('equipManage/wisdomScreenSoftware'),
                name: 'wisdomScreen',
                title: '智慧屏软件管理',
                meta: {
                    title: '智慧屏软件管理', // 页签标题
                    icon: 'icon-user', // 页签图标，可选
                    tips: '', // 页签提示，可选，如未设置则跟title一致
                    aliveId: 'fullPath' // 路由打开页签规则，可选
                },
                hidden: false //是否隐藏菜单
            },
            {
                path: '/equipDetail',
                component: importPage('equipManage/equipDetail'),
                name: 'equipDetail',
                title: '设备型号管理',
                meta: {
                    title: '设备型号管理', // 页签标题
                    icon: 'icon-user', // 页签图标，可选
                    tips: '', // 页签提示，可选，如未设置则跟title一致
                    aliveId: 'fullPath' // 路由打开页签规则，可选
                },
                hidden: false //是否隐藏菜单
            },
            {
                path: '/equipCate',
                component: importPage('equipManage/equipCate'),
                name: 'equipCate',
                title: '设备类型管理',
                meta: {
                    title: '设备类型管理', // 页签标题
                    icon: 'icon-user', // 页签图标，可选
                    tips: '', // 页签提示，可选，如未设置则跟title一致
                    aliveId: 'fullPath' // 路由打开页签规则，可选
                },
                hidden: false //是否隐藏菜单
            },
            {
                path: '/equipSys',
                component: importPage('equipManage/equipSys'),
                name: 'equipSys',
                title: '设备系统管理',
                meta: {
                    title: '设备系统管理', // 页签标题
                    icon: 'icon-user', // 页签图标，可选
                    tips: '', // 页签提示，可选，如未设置则跟title一致
                    aliveId: 'fullPath' // 路由打开页签规则，可选
                },
                hidden: false //是否隐藏菜单
            },
            {
                path: '/equipBrand',
                component: importPage('equipManage/equipBrand'),
                name: 'equipBrand',
                title: '设备品牌管理',
                meta: {
                    title: '设备品牌管理', // 页签标题
                    icon: 'icon-user', // 页签图标，可选
                    tips: '', // 页签提示，可选，如未设置则跟title一致
                    aliveId: 'fullPath' // 路由打开页签规则，可选
                },
                hidden: false //是否隐藏菜单
            },
            {
                path: '/netManage',
                component: importPage('equipManage/netManage'),
                name: 'netManage',
                title: '网关管理',
                meta: {
                    title: '网关管理', // 页签标题
                    icon: 'icon-user', // 页签图标，可选
                    tips: '', // 页签提示，可选，如未设置则跟title一致
                    aliveId: 'fullPath' // 路由打开页签规则，可选
                },
                hidden: false //是否隐藏菜单
            }
        ]
    },
    {
        path: '/',
        redirect: '',
        name: 'home',
        title: '指标管理',
        iconCls: 'iconfont iconshebeizhuangtai',
        hideArrow: false, //是否隐藏菜单右侧箭头
        component: importPage('home'),
        // 子路由里配置需要通过页签打开的页面路由
        children: [
            {
                path: '/chartConfig',
                component: importPage('indexManage/chartConfig'),
                name: 'chartConfig',
                title: '图表配置',
                meta: {
                    title: '图表配置', // 页签标题
                    icon: 'icon-user', // 页签图标，可选
                    tips: '', // 页签提示，可选，如未设置则跟title一致
                    aliveId: 'fullPath' // 路由打开页签规则，可选
                },
                hidden: false //是否隐藏菜单
            },
            {
                path: '/indexComponentGallery',
                component: importPage('indexManage/indexComponentGallery'),
                name: 'indexComponentGallery',
                title: '指标组件库',
                meta: {
                    title: '指标组件库', // 页签标题
                    icon: 'icon-user', // 页签图标，可选
                    tips: '', // 页签提示，可选，如未设置则跟title一致
                    aliveId: 'fullPath' // 路由打开页签规则，可选
                },
                hidden: false //是否隐藏菜单
            }
        ]
    },
    {
        path: '/',
        redirect: '',
        name: 'home',
        title: '内容管理',
        iconCls: 'iconfont iconshebeizhuangtai',
        hideArrow: false, //是否隐藏菜单右侧箭头
        component: importPage('home'),

        // 子路由里配置需要通过页签打开的页面路由
        children: [
            {
                path: '/contentClass',
                component: importPage('contentManage/contentClass'),
                name: 'contentClass',
                title: '分类管理',
                meta: {
                    title: '分类管理', // 页签标题
                    icon: 'icon-user', // 页签图标，可选
                    tips: '', // 页签提示，可选，如未设置则跟title一致
                    aliveId: 'fullPath' // 路由打开页签规则，可选
                },
                hidden: false //是否隐藏菜单
            },
            {
                path: '/contentManage',
                component: importPage('contentManage/contentManage'),
                name: 'contentManage',
                title: '内容管理',
                meta: {
                    title: '内容管理', // 页签标题
                    icon: 'icon-user', // 页签图标，可选
                    tips: '', // 页签提示，可选，如未设置则跟title一致
                    aliveId: 'fullPath' // 路由打开页签规则，可选
                },
                hidden: false //是否隐藏菜单
            }
        ]
    },
    {
        path: '/userRole',
        redirect: '/userRole',
        name: 'home',
        title: '角色权限管理',
        iconCls: 'iconfont icontongzhigonggao',
        hideArrow: true, //是否隐藏菜单右侧箭头
        component: importPage('home'),

        // 子路由里配置需要通过页签打开的页面路由
        children: [
            {
                path: '/userRole',
                component: importPage('userRole/userRole'),
                name: 'userRole',
                title: '角色权限管理',
                meta: {
                    title: '角色权限管理', // 页签标题
                    icon: 'icon-user', // 页签图标，可选
                    tips: '', // 页签提示，可选，如未设置则跟title一致
                    aliveId: 'fullPath' // 路由打开页签规则，可选
                },
                hidden: true //是否隐藏菜单
            }
        ]
    },
    {
        path: '/orgUserManage',
        redirect: '/orgUserManage',
        name: 'home',
        title: '组织机构用户管理',
        iconCls: 'iconfont icontongzhigonggao',
        hideArrow: true, //是否隐藏菜单右侧箭头
        component: importPage('home'),

        // 子路由里配置需要通过页签打开的页面路由
        children: [
            {
                path: '/orgUserManage',
                component: importPage('orgUserManage/orgUserManage'),
                name: 'orgUserManage',
                title: '组织机构用户管理',
                meta: {
                    title: '组织机构用户管理', // 页签标题
                    icon: 'icon-user', // 页签图标，可选
                    tips: '', // 页签提示，可选，如未设置则跟title一致
                    aliveId: 'fullPath' // 路由打开页签规则，可选
                },
                hidden: true //是否隐藏菜单
            }
        ]
    },
    {
        path: '/operaLog',
        redirect: '/operaLog',
        name: 'home',
        title: '操作日志',
        iconCls: 'iconfont icontongzhigonggao',
        hideArrow: true, //是否隐藏菜单右侧箭头
        component: importPage('home'),

        // 子路由里配置需要通过页签打开的页面路由
        children: [
            {
                path: '/operaLog',
                component: importPage('operaLog/operaLog'),
                name: 'operaLog',
                title: '操作日志',
                meta: {
                    title: '操作日志', // 页签标题
                    icon: 'icon-user', // 页签图标，可选
                    tips: '', // 页签提示，可选，如未设置则跟title一致
                    aliveId: 'fullPath' // 路由打开页签规则，可选
                },
                hidden: true //是否隐藏菜单
            }
        ]
    },
    {
        path: '/baseInfo',
        redirect: '/baseInfo',
        name: 'home',
        title: '基本信息',
        iconCls: 'iconfont icontongzhigonggao',
        hideArrow: true, //是否隐藏菜单右侧箭头
        component: importPage('home'),

        // 子路由里配置需要通过页签打开的页面路由
        children: [
            {
                path: '/baseInfo',
                component: importPage('baseInfo/baseInfo'),
                name: 'baseInfo',
                title: '基本信息',
                meta: {
                    title: '基本信息', // 页签标题
                    icon: 'icon-user', // 页签图标，可选
                    tips: '', // 页签提示，可选，如未设置则跟title一致
                    aliveId: 'fullPath' // 路由打开页签规则，可选
                },
                hidden: true //是否隐藏菜单
            }
        ]
    },
    {
        path: '/intendedCustomers',
        redirect: '/intendedCustomers',
        name: 'home',
        title: '意向客户',
        iconCls: 'iconfont icontongzhigonggao',
        hideArrow: true, //是否隐藏菜单右侧箭头
        component: importPage('home'),

        // 子路由里配置需要通过页签打开的页面路由
        children: [
            {
                path: '/intendedCustomers',
                component: importPage('intendedCustomers/intendedCustomers'),
                name: 'intendedCustomers',
                title: '意向客户',
                meta: {
                    title: '意向客户', // 页签标题
                    icon: 'icon-user', // 页签图标，可选
                    tips: '', // 页签提示，可选，如未设置则跟title一致
                    aliveId: 'fullPath' // 路由打开页签规则，可选
                },
                hidden: true //是否隐藏菜单
            }
        ]
    },
    {
        path: '/nfcManage',
        redirect: '/nfcManage',
        name: 'home',
        title: 'NFC管理',
        iconCls: 'iconfont icontongzhigonggao',
        hideArrow: true, //是否隐藏菜单右侧箭头
        component: importPage('home'),

        // 子路由里配置需要通过页签打开的页面路由
        children: [
            {
                path: '/nfcManage',
                component: importPage('nfcManage/nfcManage'),
                name: 'nfcManage',
                title: 'NFC管理',
                meta: {
                    title: 'NFC管理', // 页签标题
                    icon: 'icon-user', // 页签图标，可选
                    tips: '', // 页签提示，可选，如未设置则跟title一致
                    aliveId: 'fullPath' // 路由打开页签规则，可选
                },
                hidden: true //是否隐藏菜单
            }
        ]
    },
    {
        path: '/thirdOrganizationManage',
        redirect: '/thirdOrganizationManage',
        name: 'home',
        title: '第三方机构管理',
        iconCls: 'iconfont icontongzhigonggao',
        hideArrow: true, //是否隐藏菜单右侧箭头
        component: importPage('home'),

        // 子路由里配置需要通过页签打开的页面路由
        children: [
            {
                path: '/thirdOrganizationManage',
                component: importPage('thirdOrganizationManage/thirdOrganizationManage'),
                name: 'thirdOrganizationManage',
                title: '第三方机构管理',
                meta: {
                    title: '第三方机构管理', // 页签标题
                    icon: 'icon-user', // 页签图标，可选
                    tips: '', // 页签提示，可选，如未设置则跟title一致
                    aliveId: 'fullPath' // 路由打开页签规则，可选
                },
                hidden: true //是否隐藏菜单
            }
        ]
    },
    {
        path: '/userMessage',
        redirect: '/userMessage',
        name: 'home',
        title: '用户留言',
        iconCls: 'iconfont icontongzhigonggao',
        hideArrow: true, //是否隐藏菜单右侧箭头
        component: importPage('home'),

        // 子路由里配置需要通过页签打开的页面路由
        children: [
            {
                path: '/userMessage',
                component: importPage('userMessage/userMessage'),
                name: 'userMessage',
                title: '用户留言',
                meta: {
                    title: '用户留言', // 页签标题
                    icon: 'icon-user', // 页签图标，可选
                    tips: '', // 页签提示，可选，如未设置则跟title一致
                    aliveId: 'fullPath' // 路由打开页签规则，可选
                },
                hidden: true //是否隐藏菜单
            }
        ]
    },
    {
        path: '/packageManagement',
        redirect: '/packageManagement',
        name: 'home',
        title: 'APP版本包管理',
        iconCls: 'iconfont icontongzhigonggao',
        hideArrow: true, //是否隐藏菜单右侧箭头
        component: importPage('home'),

        // 子路由里配置需要通过页签打开的页面路由
        children: [
            {
                path: '/packageManagement',
                component: importPage('packageManagement/packageManagement'),
                name: 'packageManagement',
                title: 'APP版本包管理',
                meta: {
                    title: 'APP版本包管理', // 页签标题
                    icon: 'icon-user', // 页签图标，可选
                    tips: '', // 页签提示，可选，如未设置则跟title一致
                    aliveId: 'fullPath' // 路由打开页签规则，可选
                },
                hidden: true //是否隐藏菜单
            }
        ]
    },
    {
        path: '/fireFile',
        redirect: '/fireFile',
        name: 'home',
        title: '消防档案',
        iconCls: 'iconfont icontongzhigonggao',
        hideArrow: true, //是否隐藏菜单右侧箭头
        component: importPage('home'),

        // 子路由里配置需要通过页签打开的页面路由
        children: [
            {
                path: '/fireFile',
                component: importPage('fireFile/fireFile'),
                name: 'fireFile',
                title: '消防档案',
                meta: {
                    title: '消防档案', // 页签标题
                    icon: 'icon-user', // 页签图标，可选
                    tips: '', // 页签提示，可选，如未设置则跟title一致
                    aliveId: 'fullPath' // 路由打开页签规则，可选
                },
                hidden: true //是否隐藏菜单
            }
        ]
    },
    {
        path: '/dictManagement',
        redirect: '/dictManagement',
        name: 'home',
        title: '字典管理',
        iconCls: 'iconfont icontongzhigonggao',
        hideArrow: true, //是否隐藏菜单右侧箭头
        component: importPage('home'),

        // 子路由里配置需要通过页签打开的页面路由
        children: [
            {
                path: '/dictManagement',
                component: importPage('dictManagement/dictManagement'),
                name: 'dictManagement',
                title: '字典管理',
                meta: {
                    title: '字典管理', // 页签标题
                    icon: 'icon-user', // 页签图标，可选
                    tips: '', // 页签提示，可选，如未设置则跟title一致
                    aliveId: 'fullPath' // 路由打开页签规则，可选
                },
                hidden: true //是否隐藏菜单
            }
        ]
    },

    {
        path: '/404',
        iconCls: 'el-icon-menu',
        component: importPage('404'),
        name: 'login',
        hidden: true
    },
    {
        path: '/login',
        iconCls: 'el-icon-menu',
        component: importPage('login/login'),
        name: 'login',
        hidden: true
    }
];

export default routers;



// WEBPACK FOOTER //
// ./src/router/routes.js